import { FormGroup } from "@angular/forms";

export function markAllControlsAsUnTouched(form: FormGroup | null | undefined) {
    if(!form) {
        return;
    }

    const controls = form.controls;
    if(controls) {
        const keys = Object.keys(controls);
        if(keys && keys.length) {
            keys.forEach((key) => {
                form.get(key)?.markAsUntouched();
            })
        }
    }
}

export function markAllControlsAsPristine(form: FormGroup | null | undefined) {
    if(!form) {
        return;
    }

    const controls = form.controls;
    if(controls) {
        const keys = Object.keys(controls);
        if(keys && keys.length) {
            keys.forEach((key) => {
                form.get(key)?.markAsPristine();
            })
        }
    }
}